import React, { useContext, useEffect, useState } from 'react'
import axios from '../../../../config/axios'
import { GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/styles/table-style'
import { useOutletContext } from 'react-router-dom'
import { PeopleOutletType } from '..'
import { TypeMainOutlet } from '../..'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import TenantValidation from './TenantValidation'
import ModalContext from '../../../../contexts/ModalContext'
import pen from '../../../../assets/productions/pen.svg'

interface Tenant {
  id: number
  companyName: string
  segment: string
  cnpj: string
  adminUserId: number
  adminEmail: string
  approved: string
}

const TenantTable = () => {
  const [tenants, setTenants] = useState<Tenant[]>([])
  const [loadQuantity, setLoadQuantity] = useState(50)
  const [hasMore, setHasMore] = useState(true)
  const [totalTenants, setTotalTenants] = useState<number | undefined>(undefined)
  const { setTabIndex } = useOutletContext<PeopleOutletType>()
  const { search } = useOutletContext<TypeMainOutlet>()
  const { setModalActive, setModalSection, setSelectedTenant, setRefreshCallback } = useContext(ModalContext)

  useEffect(() => {
    setTabIndex(0)
    setRefreshCallback(() => fetchTenants)
  }, [])

  useEffect(() => {
    fetchTenants()
  }, [search, loadQuantity])

  const fetchTenants = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/tenant`, {
        params: {
          search,
          limit: loadQuantity,
          offset: 0,
        }
      })
      
      const data = Array.isArray(response.data) ? response.data : response.data.data || []
      const total = typeof response.data === 'object' && typeof response.data.total === 'number' 
        ? response.data.total 
        : undefined

      setTenants(data)
      setHasMore(typeof total === 'number' ? data.length < total : false)
      setTotalTenants(total)
    } catch (error) {
      console.error('Erro ao buscar tenants:', error)
      setTenants([])
      setHasMore(false)
    }
  }

  const headerTenantTable = ['ID', 'Empresa', 'Segmento', 'CNPJ', 'Email Admin', 'Status', 'Ações']

  const handleEditTenant = (tenant: Tenant) => {
    setSelectedTenant(tenant)
    setModalSection('editTenant')
    setModalActive(true)
  }

  return (
    <>
      <GlobalTable>
        <tbody>
          <HeaderLine>
            {headerTenantTable.map((header) => (
              <Th key={header}>{header}</Th>
            ))}
          </HeaderLine>
          {tenants.map((tenant) => (
            <Tr key={tenant.id}>
              <Td>{tenant.id}</Td>
              <Td>{tenant.companyName}</Td>
              <Td>{tenant.segment}</Td>
              <Td>{tenant.cnpj}</Td>
              <Td>{tenant.adminEmail}</Td>
              <Td>
                <TenantValidation
                  situation={tenant.approved}
                  tenantId={tenant.id}
                  adminUserId={tenant.adminUserId}
                  onUpdate={fetchTenants}
                />
              </Td>
              <Td>
                <img 
                  src={pen} 
                  alt="Editar" 
                  style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                  onClick={() => handleEditTenant(tenant)}
                />
              </Td>
            </Tr>
          ))}
        </tbody>
      </GlobalTable>
      <LoadMoreButton 
        currentCount={tenants.length} 
        totalCount={totalTenants} 
        onLoadMore={() => setLoadQuantity(prev => prev + 50)}
        hasMore={hasMore}
      />
    </>
  )
}

export default TenantTable
